import { MIRROR_APP_HANDOFF_URL } from "./mirrorChannelOutcome.ts";

export const WHATSAPP_REVIEW_TTL_MS = 120_000;
export const WHATSAPP_REVIEW_PARAM = "whatsapp_review";
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;
const record = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === "object" && !Array.isArray(value);
export function whatsappReviewMessageId(search: string): string | null {
  const values = new URLSearchParams(search).getAll(WHATSAPP_REVIEW_PARAM);
  return values.length === 1 && uuid.test(values[0]) ? values[0] : null;
}
export function whatsappReviewUrl(messageId: string): string | null {
  if (!uuid.test(messageId)) return null;
  const url = new URL(MIRROR_APP_HANDOFF_URL);
  url.searchParams.set(WHATSAPP_REVIEW_PARAM, messageId);
  return url.toString();
}
/** A link names a stored request, never carries or authorizes an action. Both
 * the database's owner policies and this explicit channel/age check apply. */
export function whatsappReviewDraft(message: unknown, session: unknown, options: {
  ownerId: string; messageId: string; now?: number;
}): string | null {
  if (!uuid.test(options.ownerId) || !uuid.test(options.messageId) || !record(message) || !record(session)
    || message.id !== options.messageId || message.user_id !== options.ownerId
    || message.channel !== "whatsapp" || message.role !== "user"
    || typeof message.session_id !== "string" || !uuid.test(message.session_id)
    || session.id !== message.session_id || session.user_id !== options.ownerId || session.kind !== "whatsapp"
    || typeof message.content !== "string" || !message.content.trim() || message.content.length > 4000
    || typeof message.created_at !== "string") return null;
  const created = Date.parse(message.created_at), now = options.now ?? Date.now();
  if (!Number.isFinite(created) || !Number.isFinite(now) || created > now + 5_000
    || created + WHATSAPP_REVIEW_TTL_MS <= now) return null;
  return message.content;
}
